import { Maybe, None } from "../../misc/option";
export class DispatchAction {
    constructor(name) {
        this.name = name;
    }
    async execute(message) {
        if (!this.validate(message))
            return Maybe(this.on_invalid_message());
        this.on_valid_message();
        await this.interpret(message);
        return Maybe(this.after_valid_message());
    }
    validate(message) {
        return message.command === this.name;
    }
    on_invalid_message() {
        return {
            context: '',
            center: false,
            zoom: false,
            fail: true
        };
    }
    async interpret(message) { }
    after_valid_message() {
        return {
            context: '',
            center: false,
            zoom: false,
            fail: false
        };
    }
    set_ctx_hook(fn) {
        this.ctx = fn;
    }
    ctx() { return None.instance(); }
}
